/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FintectureCredentialsRequest } from '../models/FintectureCredentialsRequest';
import type { FintectureCredentialsResource } from '../models/FintectureCredentialsResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FintectureCredentialsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Identifiants Fintecture d'une entreprise
     * `customer_id` obligatoire (400 sinon). S'ils ne sont pas configures, renvoie un objet aux champs `null` avec `is_configured: false` et `env: "sandbox"` — ce n'est pas une erreur.
     * @param customerId
     * @returns any `FintectureCredentialsResource`
     * @throws ApiError
     */
    public adminFintectureIndex(
        customerId?: string,
    ): CancelablePromise<(FintectureCredentialsResource | {
        id: null;
        customer_id: string;
        app_id: null;
        app_id_secret: null;
        app_priv_key: null;
        env: string;
        agence_id: null;
        is_configured: boolean;
    })> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/fintecture',
            query: {
                'customer_id': customerId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Enregistrer les identifiants Fintecture
     * `app_id`, `app_id_secret`, `app_priv_key`, `env` (`sandbox` ou `production`), `agence_id` pour une entreprise. Active le paiement en ligne des factures dans l'espace client.
     * @param requestBody
     * @returns FintectureCredentialsResource `FintectureCredentialsResource`
     * @throws ApiError
     */
    public adminFintectureStore(
        requestBody: FintectureCredentialsRequest,
    ): CancelablePromise<FintectureCredentialsResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/fintecture',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Modifier les identifiants Fintecture
     * 404 `{ error }` s'ils n'existent pas.
     * @param id
     * @param requestBody
     * @returns FintectureCredentialsResource `FintectureCredentialsResource`
     * @throws ApiError
     */
    public adminFintectureUpdate(
        id: string,
        requestBody: FintectureCredentialsRequest,
    ): CancelablePromise<FintectureCredentialsResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/fintecture/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer les identifiants Fintecture
     * Desactive le paiement en ligne pour l'entreprise. Renvoie les identifiants supprimes ; 404 `{ error }` s'ils n'existent pas.
     * @param id
     * @returns FintectureCredentialsResource `FintectureCredentialsResource`
     * @throws ApiError
     */
    public adminFintectureDestroy(
        id: string,
    ): CancelablePromise<FintectureCredentialsResource> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/fintecture/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
